"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "bg-white p-5 mb-4"
};
const _hoisted_2 = { class: "uppercase font-bold text-xl border-b-1 border-gray pb-3" };
const _hoisted_3 = { class: "flex flex-col md:flex-row" };
const _hoisted_4 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_5 = { class: "w-56 text-base pt-3" };
const _hoisted_6 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_7 = { class: "w-56 text-base pt-3" };
const _hoisted_8 = { class: "flex flex-col md:flex-row" };
const _hoisted_9 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_10 = { class: "w-56 text-base pt-3" };
const _hoisted_11 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_12 = { class: "w-56 text-base pt-3" };
const _hoisted_13 = { class: "flex flex-col md:flex-row" };
const _hoisted_14 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_15 = { class: "w-56 text-base pt-3" };
const _hoisted_16 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_17 = { class: "w-56 text-base pt-3" };
const _hoisted_18 = { class: "flex flex-col md:flex-row" };
const _hoisted_19 = { class: "flex items-start w-full md:w-1/2 py-2" };
const _hoisted_20 = { class: "w-56 text-base pt-3" };
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const validators_1 = require("../../common/utils/validators");
const securityStore_1 = require("../../stores/security/securityStore");
const FileInputBase64_vue_1 = __importDefault(require("../../components/Form/FileInputBase64.vue"));
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'EndUserForm',
    props: {
        guaranteeProductReturnCreateRequest: {
            type: Object,
        },
    },
    setup(__props) {
        const securityStore = (0, securityStore_1.useSecurityStore)();
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f;
            return ((0, vue_2.unref)(securityStore).authenticatedUser !== null &&
                __props.guaranteeProductReturnCreateRequest !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("end_user_data", "End User Data", "guarantee_product_return")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("end_user_name", "End User Name", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: true,
                                required: "",
                                disabled: ((_a = __props.guaranteeProductReturnCreateRequest) === null || _a === void 0 ? void 0 : _a.customerEqualsEndUser)
                                    && !(0, vue_2.unref)(validators_1.isBlank)((0, vue_2.unref)(securityStore).authenticatedUser.customer.name),
                                modelValue: __props.guaranteeProductReturnCreateRequest.endUserName,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.guaranteeProductReturnCreateRequest.endUserName) = $event))
                            }, null, 8, ["disabled", "modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("end_user_zip_code", "End User Zip Code", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: true,
                                required: "",
                                disabled: ((_b = __props.guaranteeProductReturnCreateRequest) === null || _b === void 0 ? void 0 : _b.customerEqualsEndUser)
                                    && !(0, vue_2.unref)(validators_1.isBlank)((0, vue_2.unref)(securityStore).authenticatedUser.customer.zipCode),
                                modelValue: __props.guaranteeProductReturnCreateRequest.endUserZipCode,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((__props.guaranteeProductReturnCreateRequest.endUserZipCode) = $event))
                            }, null, 8, ["disabled", "modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("end_user_city", "End User City", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: true,
                                required: "",
                                disabled: ((_c = __props.guaranteeProductReturnCreateRequest) === null || _c === void 0 ? void 0 : _c.customerEqualsEndUser)
                                    && !(0, vue_2.unref)(validators_1.isBlank)((0, vue_2.unref)(securityStore).authenticatedUser.customer.city),
                                modelValue: __props.guaranteeProductReturnCreateRequest.endUserCity,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((__props.guaranteeProductReturnCreateRequest.endUserCity) = $event))
                            }, null, 8, ["disabled", "modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("end_user_street", "End User Street", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: true,
                                required: "",
                                disabled: ((_d = __props.guaranteeProductReturnCreateRequest) === null || _d === void 0 ? void 0 : _d.customerEqualsEndUser)
                                    && !(0, vue_2.unref)(validators_1.isBlank)((0, vue_2.unref)(securityStore).authenticatedUser.customer.street),
                                modelValue: __props.guaranteeProductReturnCreateRequest.endUserStreet,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((__props.guaranteeProductReturnCreateRequest.endUserStreet) = $event))
                            }, null, 8, ["disabled", "modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("end_user_mobile", "End User Mobile", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: true,
                                required: "",
                                disabled: ((_e = __props.guaranteeProductReturnCreateRequest) === null || _e === void 0 ? void 0 : _e.customerEqualsEndUser)
                                    && !(0, vue_2.unref)(validators_1.isBlank)((0, vue_2.unref)(securityStore).authenticatedUser.customer.mobile),
                                modelValue: __props.guaranteeProductReturnCreateRequest.endUserMobile,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((__props.guaranteeProductReturnCreateRequest.endUserMobile) = $event))
                            }, null, 8, ["disabled", "modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                            (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("end_user_email", "End User Email", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: true,
                                required: "",
                                disabled: ((_f = __props.guaranteeProductReturnCreateRequest) === null || _f === void 0 ? void 0 : _f.customerEqualsEndUser)
                                    && !(0, vue_2.unref)(validators_1.isBlank)((0, vue_2.unref)(securityStore).authenticatedUser.customer.email),
                                type: "email",
                                modelValue: __props.guaranteeProductReturnCreateRequest.endUserEmail,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((__props.guaranteeProductReturnCreateRequest.endUserEmail) = $event))
                            }, null, 8, ["disabled", "modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_18, [
                        (0, vue_2.createElementVNode)("div", _hoisted_19, [
                            (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("end_user_invoice", "End User Invoice", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(FileInputBase64_vue_1.default, {
                                "base64-encode-file": __props.guaranteeProductReturnCreateRequest.base64EncodedInvoiceFile,
                                "onUpdate:base64EncodeFile": _cache[6] || (_cache[6] = ($event) => ((__props.guaranteeProductReturnCreateRequest.base64EncodedInvoiceFile) = $event)),
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isBase64EncodedInvoiceFileValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('customer_invoice_required', 'End user invoice required', 'guarantee_product_return'),
                                accept: ".pdf, .jpg, .jpeg, .doc, .docx, .png",
                                class: "!w-fit !grow !mb-0 pt-3"
                            }, null, 8, ["base64-encode-file", "valid", "invalid-message"])
                        ])
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
